import { Middleware } from '@reduxjs/toolkit';
import { actions as authActions, getModuleState } from 'services/auth';
import { shutdownCalls } from './callShutdown';

/** Dispose owners before auth changes, outside Redux's reducer execution. */
export const callAuthMiddleware: Middleware = store => next => action => {
  const replacesScope = action.type === authActions.setWorkspace.type
    && action.payload.workspace !== getModuleState(store.getState()).workspace;
  if (action.type === authActions.logout.type || replacesScope)
    shutdownCalls(action.type === authActions.logout.type ? 'LOGOUT' : 'WORKSPACE_SWITCH');
  return next(action);
};
